<script lang="ts">
  import CollectionsList from './CollectionsList.svelte'
</script>

<CollectionsList url="/collections"/>